module.exports = __webpack_public_path__ + "img/v4-member.20e9e0ec.png";